/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * handshake request
 * @export
 * @interface AdditionalDriverRequest
 */
export interface AdditionalDriverRequest {
    /**
     * 
     * @type {string}
     * @memberof AdditionalDriverRequest
     */
    additionalDriverCode: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalDriverRequest
     */
    jwtToken: string;
}

/**
 * Check if a given object implements the AdditionalDriverRequest interface.
 */
export function instanceOfAdditionalDriverRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "additionalDriverCode" in value;
    isInstance = isInstance && "jwtToken" in value;

    return isInstance;
}

export function AdditionalDriverRequestFromJSON(json: any): AdditionalDriverRequest {
    return AdditionalDriverRequestFromJSONTyped(json, false);
}

export function AdditionalDriverRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalDriverRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'additionalDriverCode': json['additionalDriverCode'],
        'jwtToken': json['jwtToken'],
    };
}

export function AdditionalDriverRequestToJSON(value?: AdditionalDriverRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'additionalDriverCode': value.additionalDriverCode,
        'jwtToken': value.jwtToken,
    };
}

